import { render, staticRenderFns } from "./imputazioni.vue?vue&type=template&id=723e527f"
import script from "./imputazioni.vue?vue&type=script&lang=js"
export * from "./imputazioni.vue?vue&type=script&lang=js"
import style0 from "./imputazioni.vue?vue&type=style&index=0&id=723e527f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports